var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.value)?_c('div',{staticClass:"kvass-media-types-vimeo-thumbnail",style:(_vm.style),on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"kvass-media-types-vimeo-thumbnail__icon"},[_c('Icon',{attrs:{"icon":['fab', 'vimeo']}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }